import { Route, Routes } from "react-router-dom";
import SalesOrdersIndexPage from "./SalesOrdersIndexPage";
import ShopifyOrdersPage from "./channels/ShopifyOrdersPage";

const SalesOrdersRoutes = () => {
  return (
    <Routes>
      <Route index element={<SalesOrdersIndexPage />} />
      <Route path="shopify-eu" element={<ShopifyOrdersPage />} />
    </Routes>
  );
};

export default SalesOrdersRoutes;
